'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const providerValue = {
    settings: {},
    flags: {},
    isLoading: false,
};
const SettingsContext = React.createContext(providerValue);

const tenMinInMs = 10 * 60 * 1000;
const initialValue = { flags: {}, settings: {} };
function SettingsProvider({ children, getSettings, options: { onGetSettingsFail = 'keep-last', updateIntervalMs = tenMinInMs, autoUpdate = true } = {}, }) {
    const [isLoading, setLoading] = React.useState(false);
    const [value, setValue] = React.useState(initialValue);
    React.useEffect(() => {
        async function load() {
            if (isLoading)
                return;
            setLoading(true);
            try {
                const newValue = await getSettings();
                setValue(newValue);
            }
            catch (err) {
                if (onGetSettingsFail === 'reset') {
                    setValue(initialValue);
                }
            }
            finally {
                setLoading(false);
            }
        }
        load();
        let intervalId = null;
        if (autoUpdate) {
            intervalId = window.setInterval(load, updateIntervalMs);
        }
        return function cleanup() {
            if (intervalId) {
                window.clearInterval(intervalId);
            }
        };
    }, []);
    return React__default["default"].createElement(SettingsContext.Provider, { value: { ...value, isLoading } }, children);
}

function parseSettings(keys, settings) {
    return keys.map((key) => 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    key.split('.').reduce((acc, curr) => {
        const obj = acc === null ? settings : acc;
        if (!obj)
            return acc;
        return curr in obj ? obj[curr] : null;
    }, null));
}

function useSettings(keys) {
    const { isLoading, ...settings } = React.useContext(SettingsContext);
    const values = parseSettings(keys, settings);
    return { values, isLoading };
}

function withFeatureFlag(WrappedComponent, options) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const Component = (props) => {
        const { values, isLoading } = useSettings(options.flags);
        const isDisabled = values.filter((flag) => !flag).length > 0;
        if (!isDisabled && !isLoading) {
            return React__default["default"].createElement(WrappedComponent, { ...props });
        }
        if (isLoading && options.loadingComponent) {
            const LoadingComponent = options.loadingComponent;
            return React__default["default"].createElement(LoadingComponent, null);
        }
        if (options.fallbackComponent) {
            const FallbackComponent = options.fallbackComponent;
            return React__default["default"].createElement(FallbackComponent, { ...props });
        }
        return null;
    };
    Component.displayName = `withFeatureFlag(${displayName})`;
    return Component;
}

function settingsToProps(settings, keys) {
    return keys.reduce((acc, curr, index) => ({ ...acc, [curr]: settings[index] }), {});
}
function withSettings(WrappedComponent, options) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const flags = Object.values(options.settingsMap);
    const keys = Object.keys(options.settingsMap);
    const Component = (props) => {
        const { values, isLoading } = useSettings(flags);
        const settingsProps = settingsToProps(values, keys);
        if (isLoading && options.loadingComponent) {
            const LoadingComponent = options.loadingComponent;
            return React__default["default"].createElement(LoadingComponent, null);
        }
        return React__default["default"].createElement(WrappedComponent, { ...settingsProps, ...props });
    };
    Component.displayName = `withSettings(${displayName})`;
    return Component;
}

exports.SettingsProvider = SettingsProvider;
exports.useSettings = useSettings;
exports.withFeatureFlag = withFeatureFlag;
exports.withSettings = withSettings;
//# sourceMappingURL=index.js.map
